import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'formlabs-web-components/Link';
import { Grid } from 'formlabs-web-components/Grid';

import './TechSpecsItem.module.css';

const TechSpecsItem = ({
  attributes: { measurements, buttonText, buttonColor, buttonLink }
}) => {
  const measurementData = measurements.map(mData => {
    return (
      <Grid direction="y" key={`${mData.unit} ${mData.measurement}`}>
        <div styleName="measurement-input">
          <span styleName="measurement">{mData.measurement}</span>
          <span styleName="unit">{mData.unit}</span>
        </div>
        <p styleName="label small-bottom-margin">{mData.label}</p>
      </Grid>
    );
  });

  return (
    <div styleName="tech-specs-box-background">
      <div styleName="tech-specs-block">{measurementData}</div>
      {buttonText !== '' && buttonColor !== '' && buttonLink !== '' ? (
        <div styleName="cta">
          <Button to={buttonLink} color={buttonColor}>
            {buttonText}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

TechSpecsItem.propTypes = {
  attributes: PropTypes.shape({
    measurements: PropTypes.array,
    buttonText: PropTypes.string,
    buttonColor: PropTypes.oneOf(['dark', 'white', 'light', 'light-blue']),
    buttonLink: PropTypes.string
  })
};

export default TechSpecsItem;
